// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"756a6777","87":"dee42aa0","104":"c37332b3","146":"c3f57cd7","158":"e8d4056b","168":"d7dd94a4","318":"bbb31fd1","346":"c65c63a4","377":"8b74ca8b","424":"616fbe92","453":"4c16b645","946":"4119b58a"}[chunkId] + ".chunk.js";
};